<ng-template #loaderBlock>
  <app-loader></app-loader>  
</ng-template>
<div class="keyhighlight-wrapper">
  <div
    *ngFor="let keyHighlight of keyHighlights"
    class="highlight-card"
    [ngClass]="{
      high: keyHighlight.priorityText === 'High',
      medium: keyHighlight.priorityText === 'Medium',
      low: keyHighlight.priorityText === 'Low'
    }"
  >
    <div class="priority">
      <div class="header">
        <label
          class="priority-label"
          [ngClass]="{
            'high-priority': keyHighlight.priorityText === 'High',
            'medium-priority': keyHighlight.priorityText === 'Medium',
            'low-priority': keyHighlight.priorityText === 'Low'
          }"
          >{{ keyHighlight.priorityText }}</label
        >
        <label class="date">{{
          keyHighlight.eventDate | date : "dd/MM/yyyy"
        }}</label>
      </div>
      <div class="description" [title]="keyHighlight.description">
        {{ keyHighlight.description }}
      </div>
    </div>
    <div class="status">
      <img src="/assets/images/done.svg" />
      <label>Done</label>
    </div>
  </div>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
